import { Button, Grid, Typography } from "@material-ui/core";
import logo from "../assets/stoqqyLogo.svg";
import { useSelector } from "react-redux";
import Iubenda from "react-iubenda-policy";
import Disclaimer from "./Disclaimer";
import { useState } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const textStyle = {
  color: "#16063b",
  fontFamily: "Overpass",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: 1.5,
  textDecoration: "underline",
  cursor: "pointer",
};

const Footer = ({ t }) => {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  return (
    <div
      style={{
        backgroundColor: "#f8f8f8",
        height: isDesktopOrLaptop ? "97px" : "120px",
        display: isDesktopOrLaptop ? "flex" : null,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        left: 0,
      }}
    >
      <Disclaimer open={disclaimerOpen} setOpen={setDisclaimerOpen} t={t} />
      {isDesktopOrLaptop ? (
        <Grid item xs={10} style={{ display: "flex" }}>
          <Grid
            item
            xs={9}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={logo}
              style={{
                width: "121px",
                height: "20px",
                objectFit: "contain",
              }}
              alt="logo"
            ></img>
            <Typography
              style={{
                color: "#A09A9A",
                fontSize: "11px",
                fontWeight: "normal",
                paddingLeft: "10px",
              }}
            >
              6.6 02/12/2021
            </Typography>
          </Grid>

          <Grid
            item
            xs={1}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div style={{ textDecoration: "none" }}>
              <Iubenda id={78891927} type="privacy" styling="nostyle">
                <Typography style={textStyle}>{"Privacy"}</Typography>
              </Iubenda>
            </div>

            <div
              style={{
                width: "25%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography style={textStyle}>{"|"}</Typography>
            </div>
          </Grid>

          <Grid
            item
            xs={1}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
            onClick={() => {
              setDisclaimerOpen(true);
            }}
          >
            <Typography style={textStyle}>{"Disclaimer"}</Typography>
            <div
              style={{
                width: "25%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography style={textStyle}>{"|"}</Typography>
            </div>
          </Grid>
          <Grid
            item
            xs={1}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Link to="/contact-us">
              <Typography style={textStyle}> {t("contacts")}</Typography>
            </Link>
            <div
              style={{
                width: "25%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></div>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid
            container
            justifyContent="center"
            style={{ paddingTop: "25px", paddingBottom: "5px" }}
          >
            <img
              src={logo}
              style={{
                width: "121px",
                height: "20px",
                objectFit: "contain",
              }}
              alt="logo"
            ></img>
          </Grid>
          <Grid container style={{ display: "flex" }}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Typography
                style={{
                  color: "#A09A9A",
                  fontSize: "11px",
                  fontWeight: "normal",
                  paddingLeft: "10px",
                }}
              >
                6.6 02/12/2021
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            style={{ display: "flex", padding: "23px 11px 0px 11px" }}
          >
            <Grid
              item
              xs={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <Grid item xs={12}>
                <Iubenda id={78891927} type="privacy" styling="nostyle">
                  <div style={{ textDecoration: "none" }}>
                    <Typography style={textStyle}>{"Privacy"}</Typography>
                  </div>
                </Iubenda>
              </Grid>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Typography style={textStyle}>{"|"}</Typography>
              </div>
            </Grid>

            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  setDisclaimerOpen(true);
                }}
              >
                <Typography style={textStyle}>{"Disclaimer"}</Typography>
              </Grid>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Typography style={textStyle}>{"|"}</Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link to="/contact-us">
                <Typography style={textStyle}>{t("contacts")}</Typography>
              </Link>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};
export default withNamespaces()(Footer);
